import { ITCIMarketplaceConnector, ITCIMarketplaceProvider, TCITenantAppType } from "@tci/common";

const mockConnectors: ITCIMarketplaceConnector[] = [
    {
        "id": "1",
        "name": "cvent",
        "description": "Cvent Connector for TIBCO Scribe Online",
        "tenantType": TCITenantAppType.scribe,
        "distIcon": "",
        "largeIcon": "",
        "smallIcon": "",
        "techIcon": "",
        "details": {
            "cert_dt": new Date("2019-04-17T21:40:29.126Z"),
            "certified": false,
            "commercial_lic": false,
            "commercial_lic_url": "",
            "dist_by": "",
            "dist_dt": 0,
            "install_url": "",
            "installed": false,
            "uninstallable": true,
            "upload_dt": 0,
            "uninstall_url": "",
            "isFree": true
        }
    },
    {
        "id": "2",
        "name": "Jira",
        "description": "",
        "tenantType": TCITenantAppType.flogo,
        "distIcon": "",
        "largeIcon": "",
        "smallIcon": "",
        "techIcon": "",
        "details": {
            "cert_dt": new Date("2019-04-17T21:40:29.126Z"),
            "certified": false,
            "commercial_lic": false,
            "commercial_lic_url": "",
            "dist_by": "",
            "dist_dt": 0,
            "install_url": "",
            "installed": true,
            "uninstallable": false,
            "upload_dt": 0,
            "uninstall_url": "",
            "isFree": true
        }
    },
    {
        "id": "3",
        "name": "hrnx",
        "description": "",
        "tenantType": TCITenantAppType.flogo,
        "distIcon": "",
        "largeIcon": "",
        "smallIcon": "",
        "techIcon": "",
        "details": {
            "cert_dt": new Date("2019-04-17T21:40:29.126Z"),
            "certified": false,
            "commercial_lic": false,
            "commercial_lic_url": "",
            "dist_by": "",
            "dist_dt": 0,
            "install_url": "https://www.hrnx.com/contact/",
            "installed": true,
            "uninstallable": true,
            "upload_dt": 0,
            "uninstall_url": "",
            "isFree": false
        }
    },
    {
        "id": "4",
        "name": "Marketo",
        "description": "",
        "tenantType": TCITenantAppType.scribe,
        "distIcon": "",
        "largeIcon": "",
        "smallIcon": "",
        "techIcon": "",
        "details": {
            "cert_dt": new Date("2019-04-17T21:40:29.126Z"),
            "certified": false,
            "commercial_lic": false,
            "commercial_lic_url": "",
            "dist_by": "",
            "dist_dt": 0,
            "install_url": "",
            "installed": true,
            "uninstallable": false,
            "upload_dt": 0,
            "uninstall_url": "",
            "isFree": true
        }
    }
];

const mockProviders: ITCIMarketplaceProvider[] = [
    {
        "displayName": "Scribe",
        "name": TCITenantAppType.scribe.toString(),
        "count": 1,
        "selected": false

    },
    {
        "displayName": "Flogo",
        "name": TCITenantAppType.flogo.toString(),
        "count": 1,
        "selected": false
    }
];

export { mockConnectors, mockProviders };
